// Use the label's whole-percent policy for health colours and gauge position.
export const getDisplayedHealthPercent = (value: number): number => Math.round(value);
